module.exports = __webpack_public_path__ + "img/2015004.e4144bc7.svg";